const PaymentsTypes = Object.freeze({
  REQUEST_PAYMENTS: '@@Payments/RequestPayments',
  REQUEST_PAYMENTS_OK: '@@Payments/RequestPaymentsOk',
  REQUEST_PAYMENTS_ERR: '@@Payments/RequestPaymentsErr'
});

export { PaymentsTypes };
